import type { Review } from './types';
import { clampRating, sortNewestFirst } from './format';
import { Stars } from './Stars';
import { Ticker } from './Ticker';
import { StoreImage } from '../../ui/StoreImage';

/** "Vad kunderna säger": samma recensioner som i recensionsvyn, som en rullande rad. */
export function ReviewTicker({ reviews, title = 'Vad kunderna säger' }: { reviews: Review[]; title?: string }) {
  const items = sortNewestFirst(reviews).filter((r) => r.text && r.text.trim().length > 0);
  if (items.length === 0) return null;
  return (
    <section className="cn-section">
      <Ticker
        label={title}
        title={title}
        items={items}
        getKey={(r) => r.id}
        renderItem={(r) => (
          <article className="cn-tick-review">
            <Stars rating={clampRating(r.rating)} size={15} />
            <p className="cn-tick-review__text">”{r.text.trim()}”</p>
            <p className="cn-tick-review__name">
              {r.avatarUrl && <StoreImage className="cn-avatar cn-avatar--sm" src={r.avatarUrl} width={128} alt="" loading="lazy" decoding="async" />}
              {r.name}
            </p>
          </article>
        )}
      />
    </section>
  );
}
